import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class ContestImporterChannelSubscription {
  public subscription: Subscription;
  private readonly contestImporterId: number;

  constructor(contestImporterId: number, { received, connected = undefined, disconnected = undefined }) {
    this.contestImporterId = contestImporterId;
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: "ContestImporterChannel",
        id: this.contestImporterId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}